/* eslint-disable no-underscore-dangle */
// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { BaseQueryApi, createApi } from "@reduxjs/toolkit/query/react";
import axios, { AxiosError } from "axios";
import { setToken } from "store/reducers/auth/auth.reducer";
import { BaseQueryFuncOptions, Response } from "./api.type";
import { tagTypes } from "./api.constant";

const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:6002";

export const api = createApi({
  tagTypes,
  baseQuery: async (
    { url: endpointUrl, method, payload, body, query }: BaseQueryFuncOptions,
    apiQuery: BaseQueryApi
  ) => {
    try {
      const { dispatch } = apiQuery;

      const url = `${apiUrl}/${endpointUrl}`;

      const client = axios.create();
      const accessToken = localStorage.getItem("token");
      client.interceptors.response.use(
        (response) => response,
        async (error: AxiosError) => {
          if (error.response?.status === 401) {
            localStorage.removeItem("token");
            dispatch(
              setToken({
                token: null,
                userId: undefined,
              })
            );
            return Promise.reject(error);
          }
          return Promise.reject(error);
        }
      );

      // Determine the data to send and headers
      const requestData = body || payload;
      const headers: Record<string, string> = {
        Authorization: accessToken || "",
      };

      // For FormData, let axios set the Content-Type header automatically
      if (!(requestData instanceof FormData)) {
        headers["Content-Type"] = "application/json";
      }

      const axiosConfig: any = {
        method,
        data: requestData,
        headers,
      };

      // Add query parameters for GET requests
      if (query && method === "get") {
        axiosConfig.params = query;
      }

      const { data: axiosData } = await client<Partial<Response>>(url, axiosConfig);

      return { data: axiosData?.data || axiosData };
    } catch (error) {
      return { error: error as AxiosError };
    }
  },
  endpoints: () => ({}),
});
